import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home, Account, Dropbox, Upload, Download, About, NotFound } from './pages';
import { AuthProvider } from './contexts/AuthContext';
import { DegradedModeToast, BetaBanner } from './components';

export function App() {
  return (
    <AuthProvider>
    <BrowserRouter>
      <BetaBanner />
      <DegradedModeToast />
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Upload flow - supports ?mode=send|store|quick */}
        <Route path="/upload" element={<Upload />} />

        {/* Account / Auth */}
        <Route path="/account" element={<Account />} />
        <Route path="/account/received" element={<Account />} />
        <Route path="/account/sent" element={<Account />} />
        <Route path="/account/stored" element={<Account />} />
        {/* Settings (opens Account with settings panel) */}
        <Route path="/settings" element={<Account />} />
        {/* Legacy routes — redirect for bookmarks */}
        <Route path="/mailbox" element={<Account />} />
        <Route path="/mailbox/*" element={<Account />} />

        {/* Download */}
        <Route path="/download/:reference" element={<Download />} />
        <Route path="/download/:reference/:filename" element={<Download />} />
        {/* Download with encrypted Swarm reference (privacy-preserving) */}
        <Route path="/download/e/:encryptedRef" element={<Download />} />
        <Route path="/download/e/:encryptedRef/:filename" element={<Download />} />

        {/* About */}
        <Route path="/about" element={<About />} />

        {/* Dropbox (anonymous send to user) */}
        <Route path="/send/:username" element={<Dropbox />} />

        {/* 404 — must be before /:username wildcard */}
        <Route path="/404" element={<NotFound />} />

        {/* Username wildcard — MUST be last */}
        <Route path="/:username" element={<Dropbox />} />
      </Routes>
    </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
